import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { db } from '../../../../firebase';
import { collection, onSnapshot, getDocs } from 'firebase/firestore';
import {
  pageTemplatesLoadedAction,
  pagesLoadedAction
} from '../../../actions/preloaded';
import { dataCompletedAction } from '../../../actions/store';

const usePagesLoader = () => {
  const [options, setOptions] = useState({ execute: false });

  const dispatch = useDispatch();

  const load = () => {
    dispatch(dataCompletedAction({ slice: 'Preloaded', path: 'pages' }));
    return onSnapshot(
      collection(db, 'pages'),
      async querySnapshot => {
        const items = [];

        querySnapshot.forEach(doc => {
          const dataItem = doc.data();
          dataItem.id = doc.id;
          if (!dataItem.deleted) {
            items.push(dataItem);
          }
        });

        await Promise.all(
          items.map(async page => {
            const stepsSnapshot = await getDocs(
              collection(db, `pages/${page.id}/page_states`)
            );
            let states = [];
            stepsSnapshot.forEach(doc => {
              states.push({
                id: doc.id,
                ...doc.data()
              });
            });
            page.states = states;
          })
        );

        await Promise.all(
          items.map(async page => {
            const stepsSnapshot = await getDocs(
              collection(db, `pages/${page.id}/page_roles`)
            );
            let roles = [];
            stepsSnapshot.forEach(doc => {
              roles.push({
                id: doc.id,
                ...doc.data()
              });
            });
            page.roles = roles;
          })
        );

        dispatch(pagesLoadedAction(items));
      },
      error => {
        console.error('usePagesLoader.onSnapshot', error);
      }
    );
  };

  useEffect(() => {
    let unSub = () => {};
    if (options.execute) {
      unSub = load();
    }
    return () => {
      unSub();
    };
  }, [options]);

  return {
    loadPages: (options = {}) => {
      setOptions({ ...options, execute: true });
    }
  };
};

const usePageTemplatesLoader = () => {
  const [options, setOptions] = useState({ execute: false });

  const dispatch = useDispatch();

  const load = () => {
    dispatch(
      dataCompletedAction({ slice: 'Preloaded', path: 'pageTemplates' })
    );
    return onSnapshot(
      collection(db, 'pages_templates'),
      async querySnapshot => {
        const items = [];

        querySnapshot.forEach(doc => {
          const dataItem = doc.data();
          dataItem.id = doc.id;
          items.push(dataItem);
        });

        dispatch(pageTemplatesLoadedAction(items));
      },
      error => {
        console.error('usePageTemplatesLoader.onSnapshot', error);
      }
    );
  };

  useEffect(() => {
    let unSub = () => {};
    if (options.execute) {
      unSub = load();
    }
    return () => {
      unSub();
    };
  }, [options]);

  return {
    loadPageTemplateAndSnippets: (options = {}) => {
      setOptions({ ...options, execute: true });
    }
  };
};

export { usePagesLoader, usePageTemplatesLoader };
